<div class="header">
    <h1>{{title}}</h1>
    <div class="spacer"></div>
    <ng-container *ngIf="isEditable">
        <btn *ngIf="!isEdit"
             type="actionMore"
             icon="fa-pen"
             (onClick)="edit()"></btn>
        <btn *ngIf="isEdit"
             type="actionPrincipal"
             icon="fa-check"
             (onClick)="edit()"></btn>
    </ng-container>

</div>
<div class="description" *ngIf="description">
    <label [innerHTML]="description"></label>
</div>

<mat-tab-group animationDuration="1000ms" *ngIf="!(booking | hasOneQuote)">
    <div *ngFor="let quote of booking.quotes; let index = index">
        <mat-tab [label]="quote.introduction.title">
            <div class="content">
                <watabilight-quote-details #quote
                                           [id]="index"
                                           [isLatestOutputForAgency]="isEditable"
                                           [travellers]="booking.travellers"
                                           [travellersForm]="travellersForm"
                                           [quote]="quote"
                                           [form]="form.controls[quote.idItem]"
                                           [isEdit]="isEdit"
                                           (onEdit)="onEdit.emit($event)"></watabilight-quote-details>
            </div>
        </mat-tab>
    </div>
</mat-tab-group>
<ng-container *ngIf="booking | hasOneQuote">
    <div class="content">
        <watabilight-quote-details #quote
                                   [id]="0"
                                   [isLatestOutputForAgency]="isEditable"
                                   [travellers]="booking.travellers"
                                   [travellersForm]="travellersForm"
                                   [quote]="booking.quotes[0]"
                                   [form]="form.controls[booking.quotes[0].idItem]"
                                   [isEdit]="isEdit"
                                   (onEdit)="onEdit.emit($event)"></watabilight-quote-details>
    </div>
</ng-container>
